export const blockedFallbackTitle = "Mw9pme";
export const blockedFallbackDescription = "KVFTG";
export const mismatchFallbackTitle = "YHvrRd";
export const mismatchFallbackDescription = "OgRCoc";
export const errorFallbackTitle = "_xCqIc";
export const errorFallbackDescription = "un3nRe";
export const rewardsSignInButton = "G0P2Ne";
export const goToRewardsButton = "L153Se";
export default {blockedFallbackTitle,blockedFallbackDescription,mismatchFallbackTitle,mismatchFallbackDescription,errorFallbackTitle,errorFallbackDescription,rewardsSignInButton,goToRewardsButton};